<!-- <app-modal [template]="templateSpecialPayments"></app-modal> -->
<app-preloader *ngIf="isLoading"></app-preloader>

<div>
  <div class="payments">
    <div class="tableWrapper">
      <!-- Tabla Pagos especiales -->
      <div class="customTable pagosEspeciales">
        <div class="header">
          <div class="cell numero">Nº</div>
          <div class="cell mes">Mes</div>
          <div class="cell tipo">Tipo de Pago</div>
          <div class="cell importe">Importe</div>
          <!-- <div class="cell mes">Meses</div> -->
          <div class="cell tipo">Aplica a</div>

          <div class="cell acciones" *ngIf="!isEdit"></div>
        </div>

        <div class="row" *ngFor="let item of listPayments; let i = index">
          <div class="cell numero">{{ item.period }}</div>
          <div class="cell mes">
            {{ formatDateMonthAndYear(item.paymentDate) }}
          </div>
          <div class="cell tipo">{{ getPaymentType(item.paymentType) }}</div>
          <div class="cell importe">{{ item.amount | currency : "" : "" }}</div>
          <!-- <div class="cell mes"></div> -->
          <div class="cell tipo">{{ getApplyTo(item.applyTo) }}</div>
          <div class="cell acciones" *ngIf="!isEdit && !isCalculateDisable()">
            <a (click)="edit(item)" class="edit" tp="Editar pago especial"
              >Editar</a
            >
            <a
              (click)="openModalConfirmation(item)"
              class="delete"
              tp="Eliminar pago especial"
              >Eliminar</a
            >
          </div>
        </div>
      </div>

      <button class="tertiary" (click)="newSpecialPayment()" *ngIf="!isEdit && !isCalculateDisable()">
        <i class="icon"></i>
        Nuevo período de gracia o pago especial
      </button>
    </div>
  </div>
</div>
<ng-template #modalPayments>
  <app-grace-special-payments
    [quoteType]="this.quoteType"
    [period]="period"
    [periodList]="periodList"
    [idQuote]="idQuote"
    [idDeal]="idDeal"
    [financialProduct]="financialProduct"
    (newPayment)="update($event)"
    (deletePayment)="delete($event)"
  ></app-grace-special-payments>
</ng-template>

<ng-template #templateConfirmation>
  <app-template-confirmation
    [title]="title"
    [subtitle]="subtitle"
    [btn1]="btn1"
    [btn2]="btn2"
    (closeModal)="closeModal()"
    (actionBtn2)="delete(period)"
  ></app-template-confirmation>
</ng-template>
